import getDecorators from "inversify-inject-decorators";
import container from "../../ioc/inversify.config";
import TYPES from "../../ioc/types";
import { KeyboardMappingService } from "../../services/keyboardmapping-service";
import { InventoryDTO } from "../../shared/dtos";
import { SceneId } from "../../shared/enum";
import { DefaultGridMenu } from "../components/base-menu";
import { ItemDescription } from "../components/inventory/item-description";
import { InventoryItem } from "../components/inventory/inventory-item";
import { GeometryService } from "../ui-services/geometry-ui-service";
import { MenuSceneParams } from "../../shared/domain";

const { lazyInject } = getDecorators(container);

export class InventoryMenu extends DefaultGridMenu<InventoryItem> {
    private inventory: InventoryDTO;

    private inventoryDescription: ItemDescription;

    public scene: Phaser.Scene;

    @lazyInject(TYPES.GeometryService)
    private geometryService: GeometryService;

    @lazyInject(TYPES.KeyboardMappingService)
    private keyboardMappingService: KeyboardMappingService;

    constructor(
        x: number,
        y: number,
        width: number,
        height: number,
        inventory: InventoryDTO,
        scene: Phaser.Scene,
        itemsPerLine: number
    ) {
        super(scene, x, y, itemsPerLine);
        this.scene = scene;
        this.inventory = inventory;

        const controls = this.keyboardMappingService.getKeyboardMapping("mikado");
        this.scene.input.keyboard.on("keydown-" + controls.cancelKey, () =>
            this.scene.scene.sleep()
        );

        inventory.items.forEach((item) => {
            this.addMenuItem(new InventoryItem(0, 0, 0, 0, item, this.scene));
        });

        // Reserve space at the bottom for the item description box (30px height + 2px border + padding)
        const descriptionBoxHeight = 40;
        this.computeLayout(descriptionBoxHeight);

        if (this.menuItems && this.menuItems.length > 0) {
            this.menuItems[0].select();
            this.inventoryDescription = new ItemDescription(
                2,
                0,
                inventory.items[0].item_definition,
                this.scene
            );
        }
    }

    public refreshDescription() {
        const item = this.inventory.items[this.menuItemIndex];
        const description = item.equipped_by
            ? item.item_definition.description + "\n" + "Equipped by " + item.equipped_by
            : item.item_definition.description;
        this.inventoryDescription.setDescription(description);
    }

    public draw() {
        const graphics = this.scene.add.graphics();

        this.geometryService.initGraphicContext(graphics);

        const screenWidth = this.scene.physics.world.bounds.width;
        const screenHeight = this.scene.physics.world.bounds.height;

        this.geometryService.drawBox(0, 0, screenWidth - 1, screenHeight - 1);

        //@ts-ignore
        const menu = this.scene.add.container();

        this.menuItems.forEach((item) => menu.add(item));
        if (this.menuItems.length > 0) {
            menu.add(this.inventoryDescription);
        }
    }

    public confirm() {
        console.log(
            "trying to use ",
            this.inventory.items[this.menuItemIndex].item_definition.name
        );
        this.scene.scene.setVisible(false);
        this.scene.scene.run(SceneId.MENU_SCENE, {
            scene: this.scene,
            mode: "item_mode",
            item: this.inventory.items[this.menuItemIndex],
        } as MenuSceneParams);
    }

    public onKeyInput(keyboardEvent: KeyboardEvent) {
        super.onKeyInput(keyboardEvent);
        if (this.menuItems.length > 0) {
            this.refreshDescription();
        }
    }
}
